import type { IconData } from '@stacksjs/iconify-core'

export const pyramidShape: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M43.387 38.436C38.109 40.859 28.437 45 24 45S9.891 40.859 4.613 38.436a3.8 3.8 0 0 1-1.776-5.266C9.1 21.486 17.627 9.55 21.677 4.08a2.874 2.874 0 0 1 4.645 0C30.374 9.55 38.9 21.487 45.163 33.17a3.8 3.8 0 0 1-1.776 5.266M24 3v42\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default pyramidShape
